/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KpiCards
 */
export interface KpiCards {
    /**
     * 选中年份全年的完成订单总数
     * @type {number}
     * @memberof KpiCards
     */
    totalOrders?: number;
    /**
     * 同比增长率(%)
     * @type {number}
     * @memberof KpiCards
     */
    yoyGrowthRate?: number;
    /**
     * 当前月（截至昨日）完成订单数
     * @type {number}
     * @memberof KpiCards
     */
    monthlyOrders?: number;
    /**
     * 环比增长率(%)
     * @type {number}
     * @memberof KpiCards
     */
    momGrowthRate?: number;
    /**
     * 昨日完成订单数
     * @type {number}
     * @memberof KpiCards
     */
    yesterdayOrders?: number;
    /**
     * 日环比增长率(%)
     * @type {number}
     * @memberof KpiCards
     */
    dodGrowthRate?: number;
}

/**
 * Check if a given object implements the KpiCards interface.
 */
export function instanceOfKpiCards(value: object): value is KpiCards {
    return true;
}

export function KpiCardsFromJSON(json: any): KpiCards {
    return KpiCardsFromJSONTyped(json, false);
}

export function KpiCardsFromJSONTyped(json: any, ignoreDiscriminator: boolean): KpiCards {
    if (json == null) {
        return json;
    }
    return {
        
        'totalOrders': json['totalOrders'] == null ? undefined : json['totalOrders'],
        'yoyGrowthRate': json['yoyGrowthRate'] == null ? undefined : json['yoyGrowthRate'],
        'monthlyOrders': json['monthlyOrders'] == null ? undefined : json['monthlyOrders'],
        'momGrowthRate': json['momGrowthRate'] == null ? undefined : json['momGrowthRate'],
        'yesterdayOrders': json['yesterdayOrders'] == null ? undefined : json['yesterdayOrders'],
        'dodGrowthRate': json['dodGrowthRate'] == null ? undefined : json['dodGrowthRate'],
    };
}

export function KpiCardsToJSON(json: any): KpiCards {
    return KpiCardsToJSONTyped(json, false);
}

export function KpiCardsToJSONTyped(value?: KpiCards | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalOrders': value['totalOrders'],
        'yoyGrowthRate': value['yoyGrowthRate'],
        'monthlyOrders': value['monthlyOrders'],
        'momGrowthRate': value['momGrowthRate'],
        'yesterdayOrders': value['yesterdayOrders'],
        'dodGrowthRate': value['dodGrowthRate'],
    };
}

